<template>
   <section class="my-6 px-6 flex pb-20 flex-wrap lg:flex-nowrap box-border">
     <aside class="md:pl-16 lg:w-1/3 w-full box-border">
        <h2 class="text-5xl text-white text-shadow-pop-left">{{$t('whois')}}</h2>
        <div class="bg-white wrapper-lottie mt-4">
          <img src="@/assets/images/jesusc.png" alt="Jesus Varela">
        </div>
     </aside>
     <article class="w-full mt-10 lg:mt-0 lg:w-3/4 md:px-20
      box-border justify-center flex flex-col">
      <h3 class="text-3xl text-site-400 "> {{$t('about-subtitle')}} </h3>
      <p class="text-white text-lg mt-4">
        {{$t('about-p-1')}}
      </p>
      <p  class="text-white text-lg mt-4">
        {{$t('about-p-2')}}
      </p>
      <p  class="text-white text-lg mt-4">
        {{$t('about-p-3')}}
      </p>
     </article>
    </section>
</template>
<script>

export default {
  name: 'SectionArticle',
  data() {
    return {
    };
  },
  components: {
  },
};
</script>
<style scoped>
.wrapper-lottie {
    border-radius: 67% 33% 20% 80% / 46% 21% 79% 54% ;
  }
</style>
